(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("SiteDetailsController", siteDetailsController);

  /** @ngInject */
  function siteDetailsController(
    $stateParams,
    SiteDetailsViewModel,
    dashboardKarcherActions,
    $log,
    fromArrayToPathParam,
    $state,
    sessionData,
    webSocketsStore,
    broker,
    $scope
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onFeedChangedHandler = refreshDeviceFeed,
      forSelectedSiteDeviceKeyList = [];

    vm.siteDetailsVM = new SiteDetailsViewModel();

    vm.pageChanged = function (page, limit) {
      vm.siteDetailsVM.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.siteDetailsVM.alarmsOrderingChanged(order);
      refresh();
    };

    vm.facilityDetails = function (facility) {
      $state.go("app.dashboardTechnology.siteDetails.facilityDetails", {
        deviceId: facility.deviceId
      });
    };

    init();

    function init() {
      // If WS are not connected
      if (!webSocketsStore.isConnected()) {
        broker.initWebSockets();
      }
      $scope.$on("$destroy", destroy);
      dashboardKarcherActions
        .getKarcherSiteDetailsById($stateParams.id)
        .then(function (response) {
          forSelectedSiteDeviceKeyList = response.map(function(device) {
            return device.deviceKey;
          });
          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          vm.siteDetailsVM.refresh(response);
          refresh();
        });
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToFeedChanges(forSelectedSiteDeviceKeyList);
      }
    }

    function refreshDeviceFeed(newFeedData) {
      vm.siteDetailsVM.updateFeedValues(newFeedData);
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
      }
    }

    function refresh() {
      dashboardKarcherActions
        .getKarcherSiteAlarmList(
          "",
          "",
          "",
          fromArrayToPathParam.createPath([$stateParams.id], "sitePointId="),
          "",
          "",
          vm.siteDetailsVM.alarmsPage - 1,
          vm.siteDetailsVM.alarmsPageSize,
          vm.siteDetailsVM.alarmsOrderBy,
          vm.siteDetailsVM.alarmsOrder
        )
        .then(function (response) {
          vm.siteDetailsVM.refreshAlarmList(response);
        });
    }
  }
})();
